import green from '@material-ui/core/colors/green';
import makeStyles from '@material-ui/core/styles/makeStyles';

export const useStyle = makeStyles(() => ({
  container: {
    margin: '24px 0 24px  0',
  },
  title: {
    fontSize: '1rem',
    fontWeight: 600,
    lineHeight: 1.2,
  },
  subtitle1: {
    fontSize: '0.9rem',
  },
  subtitle2: {
    color: green[600],
    fontSize: '0.9rem',
  },
  description: {
    color: '#818b9d',
    fontSize: '0.875rem',
    fontWeight: 400,
    lineHeight: 1.5,
    letterSpacing: '0.01071em',
    wordBreak: 'break-word',
  },
  defaultPadding: {
    padding: 24,
  },
  paperImage: {
    maxWidth: 120,
    maxHeight: 120,
  },
  image: {
    maxWidth: '100%',
    maxHeight: '100%',
  },
}));
